import PropTypes from 'prop-types'

import Text from '@/components/Form/Text'
import { Delete, EditSmall } from '@/components/Icons'

const DomainName = ({
  name,
  fieldName,
  index,
  removeAddress,
  editableAddress,
  setEditableAddress,
  editAddress
}: any) => (
  <div className="flex-between address-row flex-wrap">
    {editableAddress && editableAddress.index === index ? (
      <div className="address-domain">
        <Text
          onBlur={() => editAddress(fieldName, editableAddress.index, editableAddress.address)}
          name="currentMicroapp.configuration.editableAddress.address"
          type="url"
        />
      </div>
    ) : (
      <div className="address-domain">{name}</div>
    )}
    <div className="address-actions">
      {/* TODO Make these actual buttons */}
      <EditSmall onClick={() => setEditableAddress(fieldName, index)} />
      <Delete onClick={() => removeAddress(fieldName, index)} className="remove-address" />
    </div>
  </div>
)

DomainName.displayName = 'DomainName'
DomainName.propTypes = {
  name: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  removeAddress: PropTypes.func.isRequired,
  editableAddress: PropTypes.object.isRequired,
  setEditableAddress: PropTypes.func.isRequired,
  editAddress: PropTypes.func.isRequired
}
DomainName.defaultProps = {}

export default DomainName
